<template>
    <v-autocomplete
        v-model="bandejaId"
        variant="solo"
        :items="bandejas"
        item-title="descripcion"
        item-value="id"
        :rules="obligatorio"
        :loading="cargandoBandejas"
        label="Bandeja de autorizaciones"
        required
        class="asterisco"
        @update:model-value="seleccionarBandeja"
    >
    </v-autocomplete>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorio } from '@/_helpers/rules';
    import PacienteService from '@/api/PacienteService';

    const pacienteService = new PacienteService();

    export default {
        data() {
            return {
                bandejaId: null,
                bandejas: [],
                cargandoBandejas: false,
                obligatorio : obligatorio
            }
        },
        mounted() {
            this.cargarBandejas();
        },
        methods:{
            async cargarBandejas() {
                this.cargandoBandejas = true;
                const response = await pacienteService.getBandejasAutorizacion();
                if(response && response.status === 200) {
                    this.bandejas = response.data;
                }
                this.cargandoBandejas = false;
            },
            facturadorTitle(item){
                if (!item) return '';
                return `${item.cuitFacturador} - ${item.nombre}`;
            },
            seleccionarBandeja(){
                this.$emit('bandeja-seleccionada', this.bandejaId);
            }
        }
    }
</script>